<mat-card>
  <card-header label="ARO LIST" (onClose)="hide()"></card-header>
  <mat-card-content style="margin-top: 8px">
    <mat-table mat-table [dataSource]="tableDataSource">
      <ng-container matColumnDef="symbol">
        <mat-cell style="max-width: max-content; padding: 5px 5px 5px 0px" *matCellDef="let tableRow">
          <div class="aro-table-symbol" [style.background-color]="tableRow.symbolColor"
            [style.-webkit-mask-image]="tableRow.symbol"></div>
        </mat-cell>
      </ng-container>
      <ng-container *ngFor="let valueCol of tableValuesColumns; let colIndex = index" matColumnDef="{{valueCol}}">
        <mat-cell style="padding-right: 10px" 
                  [style.min-width]="tableValuesColumnsWidth[colIndex]" 
                  [style.max-width]="tableValuesColumnsWidth[colIndex]" *matCellDef="let tableRow">
          <label class="aro-table-cell">{{tableRow[valueCol]}}</label>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="nationality">
        <mat-cell style="max-width: max-content; text-align: right; padding: 5px 2px" *matCellDef="let tableRow">
          <div class="aro-table-flag" [style.background-image]="tableRow.nationality"></div>
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: tableColumns; let rowIndex = index" 
                [ngClass]="{highlighted: tableSelected[rowIndex]}" (click)="rowClicked(rowIndex)"></mat-row>
    </mat-table>
  </mat-card-content>

  <!-- Actions -->
  <mat-card class="track-actions">
    <div gdAuto="row" gdGap="8px 15px">
      <button class="aro-table-action-button" gdRow="1" gdColumn="1" mat-stroked-button [disabled]="isAroDisabled()" (click)="onAroBtnClick()">
        <mat-icon class="aro-button-icon" inline="true">radio_button_unchecked</mat-icon>
        <span>&nbsp;&nbsp;&nbsp;{{'ARO.ARO' | translate}}</span>
      </button>
      <button class="aro-table-action-button" gdRow="1" gdColumn="2" mat-stroked-button [disabled]="isDropDisabled()">
        <mat-icon class="aro-button-icon" inline="true">radio_button_unchecked</mat-icon>
        <span>&nbsp;&nbsp;&nbsp;{{'ARO.DROP' | translate}}</span>
      </button>
    </div>
  </mat-card>

</mat-card>